<script>
import Form from "../Form.vue";
import AWS from "aws-sdk";
import api from "../../../api";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    setTopbarControls: {
      type: Function,
      required: false,
    },
    topbarControls: {
      type: Object,
      required: false,
    },
    updateSelectedItem: {
      type: Function,
      required: false,
    },
  },
  components: {
    Form,
  },
  data() {
    return {
      selectedItem: {},
      prevSelectedItem: "{}",
    };
  },
  methods: {
    getHT(dynamo_id) {
      let self = this;
      const config = {
        aws_table_name: "HT_Config",
        aws_remote_config: {},
      };

      var glblParams = {
        TableName: config.aws_table_name,
        Key: { nacsCode: dynamo_id },
      };

      AWS.config.update(config.aws_remote_config);
      const docClient = new AWS.DynamoDB.DocumentClient();

      docClient.get(glblParams, function (err, data) {
        if (err) {
          console.log(err);
        } else {
          const item = data?.Item ?? {};
          const days = item?.info?.openingHours
            ? item.info.openingHours.map((x) => ({
                timings: x.timings,
                day: x.day,
                active: x.open ? true : false,
                start_time: x.ocTimings.split("-")[0] || "",
                end_time: x.ocTimings.split("-")[1] || "",
              }))
            : [];
          let newData = {
            oldInfo: item.info,
            nacsCode: item.nacsCode,
            online_consultation: !!item.info?.ocEnabledChildren,
            isSomethingElseCondition: !!item.info?.isSomethingElseCondition,
            email: item.info?.ocEmail || "",
            min_age: item.info?.ocAgeMin?.toString() || "0",
            max_age: item.info?.ocAgeMax?.toString() || "0",
            days: days,
            message: item.info?.ocSuccessText || "",
            additionalProp1: {
              global: false,
            },
          };
          self.setSelectedItems(newData);
        }
      });
    },
    async getHTData(dynamoid) {
      let url = `/api/analytics-results/gethtdata/${dynamoid}`;

      try {
        const { data } = await api.get(url);
        const item = data?.Item ?? {};
        const days = item?.info?.openingHours
          ? item.info.openingHours.map((x) => ({
              timings: x.timings,
              day: x.day,
              active: x.open ? true : false,
              start_time: x.ocTimings.split("-")[0] || "",
              end_time: x.ocTimings.split("-")[1] || "",
            }))
          : [];
        let newData = {
          oldInfo: item.info,
          nacsCode: item.nacsCode,
          online_consultation: !!item.info?.ocEnabledChildren,
          isSomethingElseCondition: !!item.info?.isSomethingElseCondition,
          email: item.info?.ocEmail || "",
          min_age: item.info?.ocAgeMin?.toString() || "0",
          max_age: item.info?.ocAgeMax?.toString() || "0",
          days: days,
          message: item.info?.ocSuccessText || "",
          additionalProp1: {
            global: false,
          },
        };
        this.setSelectedItems(newData);
      } catch (error) {
        console.error("Error fetching FFT results", error);
      }
    },
    setSelectedItems(val) {
      this.selectedItem = val;
      this.prevSelectedItem = JSON.stringify(val);
      if (typeof this.setTopbarControls === "function") {
        this.setTopbarControls(
          null,
          null,
          this.selectedItem,
          this.prevSelectedItem
        );
      }
    },
    async getData() {
      if (this.currentPractice && this.currentPractice.additionalProp1) {
        const dynamoId = this.currentPractice.additionalProp1.dynamo;
        //  this.getHT(dynamoId);
        this.getHTData(dynamoId);
      }
    },
  },
  watch: {
    currentPractice: {
      deep: true,
      handler() {
        this.getData();
      },
    },
  },
  async mounted() {
    await this.getData();
  },
};
</script>

<template>
  <Form
    :style="item.form.style"
    :class="`col-${item.form.size} ${item.form.class}`"
    :form="item.form.form"
    :variant="item.form.variant"
    :data="selectedItem"
    :topbarControls="topbarControls"
    :selectedItem="selectedItem"
    :setSelectedItems="setSelectedItems"
    :updateSelectedItem="updateSelectedItem"
  />
</template>

<style scoped>
.simplebar-custom {
  max-height: calc(100vh - 300px);
  padding-right: 2em;
}
</style>
